import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { formatFileSize } from '../../core/functions/attachment-constraints';
import { TestCaseResultAttachment } from '../../models/attachment';

/**
 * Renders the files stored with a test case result: images inline, everything else as a
 * download link, straight from the URL the API issued.
 *
 * Those URLs are signed and short-lived (60 minutes by default), so nothing here caches
 * them — the list renders whatever the caller last handed over. A link that has expired
 * is reissued by fetching the result again, not from in here.
 */
@Component({
  selector: 'app-attachment-list',
  standalone: true,
  imports: [],
  templateUrl: './attachment-list.component.html',
  styleUrl: './attachment-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachmentListComponent {
  /** Attachments as the API last handed them over (result insert response, or a refetch). */
  readonly attachments = input<TestCaseResultAttachment[]>([]);

  readonly formatSize = formatFileSize;

  isImage(attachment: TestCaseResultAttachment): boolean {
    return attachment.contentType?.startsWith('image/') ?? false;
  }
}
